module.exports = __webpack_public_path__ + "img/emoji_15.5f948ea7.png";